import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface RequireAdminProps {
  children: React.ReactNode;
}

export default function RequireAdmin({ children }: RequireAdminProps) {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();

  // Enquanto verifica sessão, evita flicker/tela de fundo
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-50 flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-purple-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Se não autenticado ou não admin, redireciona para login admin
  if (!user || !isAdmin) {
    return <Navigate to="/admin-login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
